
<app-header></app-header>

<div class="main-layout">

    <app-dialog-message></app-dialog-message>

    <router-outlet></router-outlet>
</div>